import useAssetAvailability, {
  BorrowStatus,
} from "../../actions/explore/activate/useAssetAvailability";

export enum ExploreAssetAction {
  Borrow = "borrow",
  Open = "open",
  None = "none",
}

export function useExploreAssetActionType(asset?: VST.Bridge.Asset) {
  const { getBorrowStatus } = useAssetAvailability(asset);
  const borrowStatus = getBorrowStatus();

  if (!asset || borrowStatus === BorrowStatus.UnBorrowable) {
    return ExploreAssetAction.None;
  }
  if (
    borrowStatus === BorrowStatus.Borrowed ||
    borrowStatus === BorrowStatus.UnlimitedCreditsAndCopies
  ) {
    return ExploreAssetAction.Open;
  }
  if (borrowStatus === BorrowStatus.Borrowable) {
    return ExploreAssetAction.Borrow;
  }
  return ExploreAssetAction.None;
}
